export default "__VITE_ASSET__Bm4_jNf9__"